import tall from "../assets/Shumba/lady.jpg";
import long from "../assets/Shumba/tatenda.jpg";
import second from "../assets/Shumba/long.jpg";

export const reasons = {
  tall,
  long,
  second,
};
